"use client";

import { ArrowDown, ShieldCheck, FileText, CircleCheck as CheckCircle2 } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LegalHero() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const scopeParagraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const actions = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const scrollIndicator = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="3380" id="japaneselegalintakehero" className="relative min-h-screen w-full overflow-visible bg-background text-foreground pt-12 pb-24">
      <div className="relative mx-auto flex min-h-[calc(100vh-6rem)] max-w-[1280px] flex-col justify-between px-6 py-12 sm:px-10 lg:px-12">
        
        {}
        <div ref={eyebrow.ref} className={`transition-all duration-1000 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium tracking-wide text-primary border border-border">
            <ShieldCheck className="h-4 w-4 text-secondary" />
            <span>フロリダ州弁護士連携・完全日本語サポート</span>
          </div>
        </div>

        {}
        <div className="relative grid flex-1 grid-cols-1 items-center gap-12 py-12 lg:grid-cols-12 lg:gap-12">
          
          {}
          <div className="lg:col-span-7 lg:pr-6">
            <h1 ref={heading.ref} className={`font-serif font-bold leading-[1.15] tracking-tight text-foreground transition-all duration-[1200ms] ease-out ${heading.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-6 blur-md"}`} style={{
            fontSize: "clamp(2.5rem, 4.5vw, 4.25rem)"
          }}>
              日本語での初期相談・お問い合わせ
            </h1>

            <p ref={paragraph.ref} className={`mt-6 max-w-[580px] font-default text-lg leading-relaxed text-muted-foreground transition-all duration-1000 delay-300 ease-out sm:text-xl ${paragraph.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-4 blur-sm"}`}>フロリダ州でのビジネス、不動産、プロベート、信託関連、弁護士費用審理に関するご相談事項を、日本語でお伺いし、初期情報を整理します。</p>

            <div ref={scopeParagraph.ref} className={`mt-6 space-y-4 max-w-[580px] font-default text-sm leading-relaxed text-muted-foreground/90 transition-all duration-1000 delay-400 ease-out sm:text-base ${scopeParagraph.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-4 blur-sm"}`}>
              <p>会社・事業関連、不動産取引、遺言書が関係するプロベート、信託管理、受益者または相続人に関する問題、Attorney’s Fee Hearingsについて、日本語での情報整理、資料確認および初期連絡をサポートします。</p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                <div className="flex items-center gap-2.5 rounded-lg bg-card p-3 shadow-xs border border-border">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-secondary" />
                  <span className="text-xs font-medium text-foreground">事業・法人設立サポート</span>
                </div>
                <div className="flex items-center gap-2.5 rounded-lg bg-card p-3 shadow-xs border border-border">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-secondary" />
                  <span className="text-xs font-medium text-foreground">不動産取引・所有権移転</span>
                </div>
                <div className="flex items-center gap-2.5 rounded-lg bg-card p-3 shadow-xs border border-border">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-secondary" />
                  <span className="text-xs font-medium text-foreground">相続・遺言・プロベート</span>
                </div>
                <div className="flex items-center gap-2.5 rounded-lg bg-card p-3 shadow-xs border border-border">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-secondary" />
                  <span className="text-xs font-medium text-foreground">弁護士費用査定証言</span>
                </div>
              </div>

              <p className="text-xs text-muted-foreground/70 italic pt-1">
                ※法的判断および法律業務はフロリダ州弁護士が担当します。当サポートは正確な情報整理と円滑なコミュニケーションのためのものです。
              </p>
            </div>

            <div ref={actions.ref} className={`mt-8 flex flex-wrap items-center gap-4 transition-all duration-1000 delay-500 ease-out ${actions.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild className="rounded-lg bg-primary px-8 py-6 text-base font-medium text-primary-foreground shadow-md hover:bg-primary/90 transition-all">
                <Link to="#japanese-inquiry-form">
                  日本語で問い合わせる
                </Link>
              </Button>
              <Button asChild variant="outline" className="rounded-lg border-border px-6 py-6 text-base font-medium text-foreground hover:bg-accent hover:text-accent-foreground transition-all">
                <Link to="/JapaneseLanguageSupportPage">
                  サービス詳細を見る
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:relative">
            <div ref={image.ref} className={`relative mx-auto w-full max-w-md transition-all duration-[1400ms] ease-out lg:max-w-none ${image.isVisible ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-8 blur-md"}`}>
              <div className="overflow-hidden rounded-lg shadow-xl border border-border/50 bg-card p-2">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_office_architecture.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_office_architecture.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681339/img/legal_office_architecture.webp-wvc-sizes" alt="Modern architectural view of South Florida legal offices" loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover rounded-md" />
              </div>
            </div>
          </div>

        </div>

        {}
        <div ref={scrollIndicator.ref} className={`relative mt-12 flex items-center gap-3 transition-all duration-1000 delay-700 ease-out ${scrollIndicator.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <ArrowDown className="h-4 w-4 text-secondary animate-bounce" strokeWidth={1.5} />
          <span className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground font-medium">
            サービス内容とご相談の流れ
          </span>
        </div>

      </div>
    </section>;
}